import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import '../WhyChooseUs/WhyChooseUs.css';
import home from '../../../assets/MarysvillePage/Columbus_Roofing_Contractor_Near_You.jpg';
import Buttonanimated from './Buttonanimated';

const WhyChooseUs = () => {
  const features = [
    { title: "Local Expertise", desc: "We understand the climate, building codes, and roofing challenges specific to Marysville, Ohio." },
    { title: "Certified Installation Roofers", desc: "Our Roofing team consists of certified, experienced roofers who follow industry best practices for every project." },
    { title: "Licensed & Insured", desc: "Your property stays fully protected when you choose our licensed and insured roofing experts." },
    { title: "High-Quality Materials", desc: "We use top-quality materials from trusted manufacturers to deliver durable, long-lasting roofing solutions." },
    { title: "Honest & Transparent Approach", desc: "From the initial inspection to final project completion, we ensure clear communication and complete transparency every step of the way." },
    { title: "24/7 Emergency Response", desc: "Roof emergencies don’t follow a schedule. Our team is available 24/7 for emergency roofing solutions in Marysville, Ohio." }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', stiffness: 100, damping: 20 }
    }
  };

  const imageFrameVariants = {
    hidden: { scale: 0.9, opacity: 0, rotate: -3 },
    visible: {
      scale: 1,
      opacity: 1,
      rotate: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  return (
    <section className="cs-section wcu-section" style={{ backgroundColor: '#f8f9fa' }}>
      <Container>
        <Row className="align-items-center g-1">


          {/* Text Content (Left Side) */}
          <Col lg={6}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.8 }}
            >
              {/* badge  */}
              <div className="cs-badge wcu-subtitle-container d-flex justify-content-md-start">
                <span className="wcu-subtitle">
                  <span className="wcu-dot"></span> Why Choose Us
                </span>
              </div>

              <h2 className="cs-title cs-title-to-content wcu-title">
                Why Choose<span className="wcu-red"> Ultimates Roofing </span>  
              </h2>
            </motion.div>

            <motion.ul
              className="cs-content wcu-feature-list"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              {features.map((item, index) => (
                <motion.li
                  key={index}
                  className="wcu-feature-item"
                  variants={itemVariants}
                >
                  <div className="wcu-icon-wrapper">
                    <Check size={20} color="#b22335" strokeWidth={3} />
                  </div>
                  <div className="wcu-feature-text">
                    <span className="wcu-item-title">{item.title}:</span>
                    <span className="wcu-item-desc">{item.desc}</span>
                  </div>
                </motion.li>
              ))}
            </motion.ul>

            <div className='d-flex justify-content-lg-start  justify-content-center'>
              <Buttonanimated />
            </div>
          </Col>

          {/* Image Content (Right Side) */}
          <Col lg={6}>
            <motion.div
              className="wcu-image-container"
              variants={imageFrameVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              <div className="wcu-inner-frame">
                <img
                  src={home}
                  alt="Elegant roofing service"
                  className="wcu-img"
                />
              </div>
              <div className="wcu-badge">
                Since 2012
              </div>
            </motion.div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseUs;